'use strict';

document.addEventListener('DOMContentLoaded', () => {
  const links = document.querySelectorAll('.services-btn');
  const sections = Array.from(links)
    .map(link => document.querySelector(link.getAttribute('href')))
    .filter(Boolean);

  // --- Kliknięcie w link ---
  links.forEach(link => {
    link.addEventListener('click', function () {
      links.forEach(l => l.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // --- Scrollspy (aktywny link przy scrollu) ---
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -90% 0px', // aktywacja, gdy nagłówek sekcji dotknie góry okna
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.getAttribute('id');
        const link = document.querySelector(`.services-btn[href="#${id}"]`);

        if (link) {
          links.forEach(l => l.classList.remove('active'));
          link.classList.add('active');
        }
      }
    });
  }, observerOptions);

  sections.forEach(section => observer.observe(section));
});